{
  "screen": {
    "heading": "Change a medication order",
    "open": "Change order",
    "openNamed": "Change order: {substance}",
    "explanation": "For an order whose dosing was recorded wrongly. What changes is the dose, the route, the schedule, the indication, the end date and the status.",
    "notPrescribing": "This is not a new order. Medicines are not prescribed in this version — an order that is not in the record cannot be added here.",
    "inherited": "The medicine, the strength, the dose form, the order date and the prescriber belong to the order and do not change.",
    "appendOnly": "The current version is not removed. What you save becomes a new version, and both stay in the record with who wrote them.",
    "requiredHint": "Fields without a note must be filled in.",
    "optional": "optional",
    "save": "Save the change",
    "saving": "Saving …",
    "cancel": "Cancel",
    "close": "Close",
    "discardQuestion": "Close the form? What you have changed will not be saved.",
    "discardConfirm": "Close without saving",
    "discardCancel": "Keep filling in",
    "saved": "The change is saved."
  },
  "field": {
    "status": "Status",
    "doseUnit": "Unit",
    "isPrn": "As needed",
    "prnMaxDose24h": "Maximum dose per 24 hours",
    "endAt": "Up to and including",
    "prescriber": "Prescriber"
  },
  "fieldHint": {
    "doseAmount": "Write the dose with a decimal point: 0.25. A comma is not accepted.",
    "doseUnit": "A metric unit, for example mg, g or mikrogram. Write mikrogram out in full — µg and mcg are not accepted. IE is used for international units.",
    "route": "How the medicine is given, under the name used here.",
    "frequency": "The schedule in words, for example 1 x 2.",
    "isPrn": "Tick if the order applies as needed. A maximum dose per 24 hours is then required.",
    "prnMaxDose24h": "Write the ceiling as it was ordered, for example Max 4 doser per dygn. The record does not work it out.",
    "indication": "Indication — ordinationsorsak. Mandatory under HSLF-FS 2017:37.",
    "endAt": "Write it as YYYY-MM-DD HH:mm on a 24-hour clock, for example 2026-10-15 08:00. Leave empty for an open-ended order. The date must fall after the order date.",
    "status": "Choose Stopped for an order that has been discontinued, and Entered in error only when the order never applied."
  },
  "status": {
    "active": "Current",
    "completed": "Completed as planned",
    "stopped": "Stopped",
    "enteredInError": "Entered in error"
  },
  "refusal": {
    "doseMissing": "The dose must be filled in. The change was not saved.",
    "doseComma": "Write the dose with a decimal point: 0.25, not 0,25. The change was not saved.",
    "doseMalformed": "The dose does not read as a number. Write it with digits and a decimal point: 0.25. The change was not saved.",
    "doseNotPositive": "The dose must be greater than zero. The change was not saved.",
    "unitMissing": "The unit must be filled in. A dose with no unit cannot be read. The change was not saved.",
    "unitNotMetric": "The unit is not metric. Use mg, g, ml, mikrogram or IE. The change was not saved.",
    "unitMicrogramAbbreviated": "Write mikrogram out in full. µg and mcg get read as mg, and the difference is a thousandfold. The change was not saved.",
    "statusInvalid": "The status is not recognised. The change was not saved.",
    "fieldMissing": "{field} must be filled in. The change was not saved.",
    "fieldTooLong": "{field} is too long. At most {maximum} characters. The change was not saved.",
    "isPrnMissing": "The form did not say whether the order applies as needed. The change was not saved.",
    "prnMaxDoseMissing": "An as-needed order must have a maximum dose per 24 hours. Write the ceiling as it was ordered — the record does not work it out. The change was not saved.",
    "endAtMalformed": "The end date does not read as a time. Write it as YYYY-MM-DD HH:mm, for example 2026-10-15 08:00. The change was not saved.",
    "endBeforeStart": "The end date falls before the order date {start}. The change was not saved.",
    "notFound": "The order is not in the record. The change was not saved. Open the patient overview again.",
    "retracted": "The order is retracted in the record and cannot be changed. The change was not saved.",
    "versionStale": "Somebody else saved a new version of the order while the form was open. Open the patient overview again and check what it says. What you wrote was not saved.",
    "noChange": "Nothing differs from what the record holds. No new version was written.",
    "supersedesMissing": "The form does not know which version it started from. Close the patient overview and open it again. The change was not saved.",
    "patientNotFound": "The patient is not in the record. The change was not saved.",
    "patientRetracted": "The patient is retracted in the record. The change was not saved.",
    "roleMayNotDocument": "Your role may not document in the record. The change was not saved.",
    "unknown": "The change was not saved. Try again.",
    "unavailable": "No contact with the server. The change was not saved — leave the form open and try again."
  }
}
